import script from "./CardAttachment.vue?vue&type=script&setup=true&lang=js"
export * from "./CardAttachment.vue?vue&type=script&setup=true&lang=js"

import "./CardAttachment.vue?vue&type=style&index=0&id=56037f28&lang=css"

const __exports__ = script;

export default __exports__